/**
 * Search Field in Masthead
 * Optional part of Global Navigation. Includes conditional initialization of autosuggest,
 * and recent search history.
 */

import searchInit from '../search';
import suggestInit from '../suggest';
import recentSearchInit from '../recents';
import AriaLiveHandler from '../AriaLiveHandler';
import getScriptData from '../../../util/getScriptData';

export function app(win) {
  const {
    disableLegacyRecentSearch = false,
    enableAutosuggest = false,
    enableRecentSearch = false,
    searchAction = '',
    showSearch = false,
    useConstructorAutosuggest = false,
  } = getScriptData('gnav-data') || {};

  if (showSearch) {
    // Conditions (other than `enableAutosuggest`) where Constructor is the autosuggest experience
    const c9rAutosuggestEnabled = useConstructorAutosuggest && searchAction === '/search';
    const legacyAutosuggestShouldInit = enableAutosuggest && !c9rAutosuggestEnabled;
    const legacyRecentSearchShouldInit = enableRecentSearch && !disableLegacyRecentSearch;

    /* init the search bar (expand / contract) */
    searchInit({
      masthead: '[data-js=masthead]',
      searchForm: '[data-js=search-form]',
      searchField: '[data-js=search-field]',
      clearButton: '[data-js=clear-button]',
      searchButton: '[data-js=search-button]',
      searchCancel: '[data-js=search-cancel]',
    });
    if (legacyAutosuggestShouldInit || legacyRecentSearchShouldInit) {
      const ariaLiveInstance = AriaLiveHandler.getInstance();
      ariaLiveInstance.init({
        ariaBox1: '[data-js=feedback-holder-1]',
        ariaBox2: '[data-js=feedback-holder-2]',
        searchField: '[data-js=search-field]',
      });
    }
    if (legacyAutosuggestShouldInit) {
      /* init listboxes - autosuggest & recent search history */
      suggestInit({
        searchField: '[data-js=search-field]',
        suggestionBox: '[data-js=suggestion-box]',
        suggestionList: '[data-js=suggestion-list]',
        searchForm: '[data-js=search-form]',
      });
    }
    if (legacyRecentSearchShouldInit) {
      recentSearchInit({
        recentHistoryBox: '[data-js=recent-search-box]',
        searchForm: '[data-js=search-form]',
      });
    }
  }
  return win;
}

export function main(win = window) {
  if (win.document.readyState === 'loading') {
    // Loading hasn't finished yet
    win.document.addEventListener('DOMContentLoaded', app.bind(null, win));
  } else {
    // `DOMContentLoaded` has already fired
    app(win);
  }
}
